import React from 'react'
import Intro1 from './Componenets/Intro1';
import Intro2 from './Componenets/Intro2';
import Intro3 from './Componenets/Intro3';
import Intro4 from './Componenets/Intro4';
import Intro5 from './Componenets/Intro5';

const LandingPage = () => {
    return (
        <>

            <Intro1 />
            <Intro2 />
            <Intro3 />
            <Intro4 />

            <Intro5 />
        </>
    )
}

export default LandingPage
